// extracted by mini-css-extract-plugin
export var pillWrapper = "_ot-0";
export var showOverflow = "_ot-1";